export default __webpack_public_path__ + "static/media/svg-6.f21607d7.svg";